import { render, staticRenderFns } from "./UsersEditor.vue?vue&type=template&id=10c97b4f&scoped=true"
import script from "./UsersEditor.vue?vue&type=script&lang=js"
export * from "./UsersEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c97b4f",
  null
  
)

export default component.exports